import styled from 'styled-components';
import { 
  // COLOR, FONT
 } from 'assets';

export const CreditCardStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
`;
